var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"container mx-auto px-6 xl:px-0 pb-10"},[_c('div',{staticClass:"text-left w-full lg:w-2/3 mx-auto mt-10 privacy-policy"},[_c('SimplePageBuilder',{attrs:{"response":_vm.response}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }